import Humanize from "humanize-plus";
import empty from "is-empty";

import * as Validators from "src/utils/validators";
import { numberOrDash } from "src/utils/number";
import {
    parseFloatToSizeLimit,
    parseIntToSizeLimit,
} from "src/utils/validators";

export const EXPORT_FORMAT = {
    EXCEL: [
        {
            id: "data-type-string",
            dataType: "string",
        },
    ],
};

export const formatQuantity = (quantity, country, editable = true) => {
    if (empty(quantity) && quantity !== 0) return "-";
    if (!editable && isNaN(quantity)) return "-";
    if (!Validators.isQuantityValid(quantity, country, editable))
        return quantity;
    return Humanize.intComma(parseIntToSizeLimit(quantity));
};

export const formatRate = (rate, editable = true) => {
    if (empty(rate) && rate !== 0) return "-";
    if (!editable && isNaN(rate)) return "-";
    if (isNaN(parseFloat(rate))) return rate;
    if (!Validators.isRateValid(rate)) return rate;
    return numberOrDash({ value: parseFloatToSizeLimit(rate) });
};

export const formatDiv = (div, editable = true) => {
    if (empty(div) && div !== 0) return "-";
    if (!editable && isNaN(div)) return "-";
    if (isNaN(parseFloat(div))) return div;
    if (!Validators.isDividendValid(div)) return div;
    return numberOrDash({ value: parseFloatToSizeLimit(div) });
};
